/**
 * Autocomple option typing
 */

/**
 * Create a test function to check if a value is a concrete option.
 * Useful to create `yup`'s 'when()` discriminator functions.
 */
function getIsSelectOption(value) {
  return option => (option === null || option === void 0 ? void 0 : option.value) === value;
}

/**
 * Create a yup validator for Giger's Autocomplete form elements
 */
function getSelectValidator(availableValues) {
  return option => !!(option !== null && option !== void 0 && option.value) && availableValues.includes(option.value);
}

/**
 * Translate an autocomplete option
 */
function translateSelectOption(option, t) {
  return {
    ...option,
    label: t(option.label)
  };
}

/**
 * Translate all names in a list of autocomplete options
 */
function translateSelectOptions(options, t) {
  return options.map(option => translateSelectOption(option, t));
}

export { getIsSelectOption, getSelectValidator, translateSelectOption, translateSelectOptions };
//# sourceMappingURL=select.js.map
